import React, { Suspense, lazy, useState } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingSpinner from "./components/loader/LoadingSpinner";
import NotFoundPage from "./components/not-found-page/NotFoundPage";
import DoctorBooking from "./pages/doctor-booking/DoctorBooking";
import PaymentSuccess from "./pages/payment-pages/PaymentSuccess";
import PaymentFailure from "./pages/payment-pages/PaymentFailure";
import Confirmation from "./pages/doctor-booking/steps/Confirmation";
import LandingPage from "./pages/advanced-ivf-lab-landing/LandingPage";
import LandingPageDesign from "./pages/advanced-ivf-lab-landing/LandingPageDesign";
import BranchHome2 from "./pages/branch-page/BranchHome2";
import OnlineConsultation from "./pages/online-consultation/OnlineConsultation";
import ServiceDetails from "./pages/service-details/ServiceDetails";
import DoctorListCleaner from "./DoctorListCleaner";
import PagesDetail2 from "./pages/pages-detail2/PagesDetail2";
import InfertilityDetail2 from "./pages/infertility-detail2/InfertilityDetail2";
import NewsDetail2 from "./pages/news-and-events-detail2/NewsDetail2";
import SitemapRoute from "./components/sitemap/SitemapRoute";
import SitemapXMLRoute from "./components/sitemap/SitemapXMLRoute";
import SitemapGenerator from "./components/sitemap/SitemapGenerator";
import SitemapDebug from "./components/sitemap/SitemapDebug";

// Lazy loading the components
const Layout = lazy(() => import("./components/layout/Layout"));
const Home = lazy(() => import("./pages/home-page/Home"));
const AboutUs = lazy(() => import("./pages/about-page/AboutUs"));
const ContactUs = lazy(() => import("./pages/contact-us-page/ContactUs"));
const DoctorsPage = lazy(() => import("./pages/doctors-page/DoctorsPage"));
const BranchHome = lazy(() => import("./pages/branch-page/BranchHome"));
const DoctorBookingDetail = lazy(() =>
  import("./pages/doctor-booking-detail/DoctorBookingDetail")
);
const ServicesListing = lazy(() =>
  import("./pages/services-listing/ServicesListing")
);
const ServiceDetail = lazy(() =>
  import("./pages/service-detail/ServiceDetail")
);
const NewsAndEvents = lazy(() =>
  import("./pages/news-and-events/NewsAndEvents")
);
const NewsDetail = lazy(() =>
  import("./pages/news-and-events-detail/NewsDetail")
);
const PagesDetail = lazy(() => import("./pages/pages-detail/PagesDetail"));
const InfertilityDetail = lazy(() =>
  import("./pages/infertility-detail/PagesDetail")
);
const GalleryListing = lazy(() =>
  import("./pages/gallery/gallery-listing/GalleryListing")
);
const Testimonials = lazy(() => import("./pages/testimonials/Testimonials"));
const Careers = lazy(() => import("./pages/careers/Careers"));
const BookAppointment = lazy(() =>
  import("./pages/book-appointment/BookAppointment")
);
const GalleryDetail = lazy(() =>
  import("./pages/gallery/gallery-detail/GalleryDetail")
);
const PrivacyPolicy = lazy(() =>
  import("./pages/privacy-policy/PrivacyPolicy")
);
const InvestorAndRelations = lazy(() =>
  import("./pages/investor-and-relations/InvestorAndRelations")
);

const AppRoutes = ({ isBackNavigation, setIsBackNavigation }) => {
  const [popUpOnce, setpopUpOnce] = useState(0);
  const [popUpOnceBranch, setpopUpOnceBranch] = useState(0);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <DoctorListCleaner /> {/* <- Works inside Router context */}
      <Routes>
        <Route
          path="/"
          element={
            <Home
              popUpOnce={popUpOnce}
              setpopUpOnce={setpopUpOnce}
              isBackNavigation={isBackNavigation}
              setIsBackNavigation={setIsBackNavigation}
            />
          }
        />
        <Route
          path="/branch/:slug"
          element={
            <BranchHome
              popUpOnceBranch={popUpOnceBranch}
              setpopUpOnceBranch={setpopUpOnceBranch}
            />
          }
        />
        {/* <Route path="/about" element={<AboutUs />} /> */}
        <Route path="/services" element={<ServicesListing />} />
        <Route path="/services/:slug" element={<ServiceDetails />} />
        {/* <Route path="/services/:slug" element={<ServiceDetail />} /> */}
        {/* <Route path="/serviceDetail/:slug" element={<ServiceDetails />} /> */}
        <Route path="/blogs" element={<NewsAndEvents />} />
        <Route path="/blogs/:slug" element={<NewsDetail2 />} />
        <Route path="/pages/:slug" element={<PagesDetail2 />} />
        <Route
          path="/infertility-treatment/:slug"
          element={<InfertilityDetail2 />}
        />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/gallery" element={<GalleryListing />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/doctors" element={<DoctorsPage />} />
        <Route path="/consultation" element={<BookAppointment />} />
        <Route path="/gallery/:slug" element={<GalleryDetail />} />
        <Route path="/policy/:slug" element={<PrivacyPolicy />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
        <Route
          path="/doctor-booking-detail/:doctorId"
          element={<DoctorBookingDetail />}
        />
        <Route path="/book-doctor/:doctorId" element={<DoctorBooking />} />
        <Route
          path="/investor-and-relations"
          element={<InvestorAndRelations />}
        />
        <Route path="/careers" element={<Careers />} />
        <Route path="/advanced-ivf" element={<LandingPage />} />
        {/* <Route path="/advanced-ivf-design" element={<LandingPageDesign />} /> */}
        <Route path="/online-consultation" element={<OnlineConsultation />} />
        <Route path="/sitemap.xml" element={<SitemapXMLRoute />} />
        <Route path="/admin/sitemap-generator" element={<SitemapGenerator />} />
        <Route path="/admin/sitemap-debug" element={<SitemapDebug />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
